import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { Karte } from 'openapi';

import KartePanel from '../panels/KartePanel';

interface Props {
  karte?: Karte,
  onClose: () => void,
}

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

export default ((props) => {

  const classes = useStyles();

  return (
    <Dialog fullWidth={true} onClose={props.onClose} open={props.karte !== undefined}>
      <IconButton aria-label="close" className={classes.closeButton} onClick={props.onClose}>
        <CloseIcon />
      </IconButton>
      <KartePanel isLoading={false} karte={props.karte} />
    </Dialog>
  );
}) as React.FC<Props>;
